module.exports = __webpack_public_path__ + "img/step8.beefda2f.png";